import { Singleton as AuthService } from '@/services/authService';
import { Route } from 'vue-router';

export default async (to: Route, from: Route, next: any): Promise<void> => {
  if(to.name === 'logout'){
    AuthService.clearAuth();
    next({ name: 'login' });
    return;
  }

  const destinationRequiresAuth = !to.meta || !to.meta.noAuth;

  if(destinationRequiresAuth && !AuthService.isAuthenticated()){
    next({ name: 'logout' });
    return;
  }

  if(destinationRequiresAuth && !AuthService.hasUserDetails()){
    let loginResult = await AuthService.validate();

    if(!loginResult.success){
      next({ name: 'logout' });
      return;
    }
  }

  next();
};